import { Box, BoxProps } from '@mui/system'

interface Props {
  children: React.ReactChild | React.ReactChild[]
  gap?: string
  sx?: BoxProps
}

const HorizontalItem = ({ children, gap, sx }: Props) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap,
        ...sx,
      }}
    >
      {children}
    </Box>
  )
}

export default HorizontalItem
